import {
  FormatPersonName,
  MapFamilyMembers,
  ValueType,
  ZERO_GUID,
  parseFormValue,
  vendorContactSearchInfo,
  vendorSearchInfo
} from './formDataConstants';
import { enumColumn } from 'modules/common/enumTableColumn';

export const createLanguageTrainingRows = formDataList => {
  if (!Array.isArray(formDataList)) return [];

  return formDataList.map(data => ({
    ...data,
    contactId: data.languageTrainingVendorContactId,
    vendorId: data.languageTrainingVendorId,
    hoursApproved: parseFormValue(data.hoursApproved, ValueType.IntType),
    hourlyRate: parseFormValue(data.hourlyRate, ValueType.FloatType),
    hoursUsed: parseFormValue(data.hoursAttended, ValueType.IntType),
    orderedDate: parseFormValue(data.initiationDate, ValueType.DateTimeType),
    isServiceCompleted: data.isServiceCompleted ?? false
  }));
};

export const createLanguageTrainingPostRequest = (formData, globalId) => {
  const request = { ...formData };
  request.globalAssignmentId = globalId;
  request.modifiedBy = 1; // TODO: replace with actual user id
  request.modifiedOn = new Date().toISOString();
  request.addedBy = 1; // TODO: replace with actual user id
  request.addedOn = new Date().toISOString();
  parseLanguageTrainingFormValues(request, formData);
  return request;
};

export const createLanguageTrainingPutRequest = (originalFormData, newFormData, globalId) => {
  const request = { ...newFormData };
  request.globalAssignmentId = globalId;
  request.globalLanguageTrainingServiceId = originalFormData.globalLanguageTrainingServiceId;
  parseLanguageTrainingFormValues(request, newFormData);
  return request;
};

export const createLanguageTrainingColumns = (vendors, vendorContacts, familyMembers, countries, allVendors) => {
  return [
    {
      ...enumColumn('familyMemberId', familyMembers, { valueKey: 'familyMemberId', label: FormatPersonName }),
      header: 'Family Member',
      type: 'dropdown-v2',
      required: true,
      options: MapFamilyMembers(familyMembers),
      size: 65,
      Cell: ({ cell }) => cell.getValue() || '-'
    },
    {
      ...enumColumn('vendorId', allVendors, { valueKey: 'vendorId', label: 'companyName' }),
      header: 'Vendor (Trainer)',
      nameKey: 'companyName',
      searchInfo: vendorSearchInfo(vendors),
      type: 'advanced-search',
      required: true,
      size: 65
    },
    {
      ...enumColumn('contactId', vendorContacts, { valueKey: 'contactId', label: FormatPersonName }),
      header: 'Vendor Contact',
      nameKey: 'fullName',
      searchInfo: vendorContactSearchInfo(vendorContacts),
      type: 'advanced-search',
      required: false,
      size: 65,
      Cell: ({ cell }) => cell.getValue() || '-'
    },
    { accessorKey: 'hourlyRate', header: 'Hourly Rate', type: 'number', size: 65 },
    { accessorKey: 'hoursApproved', header: 'Hours Approved', type: 'number', size: 65 },
    { accessorKey: 'hoursUsed', header: 'Hours Used', type: 'number', size: 65 },
    {
      accessorKey: 'orderedDate',
      header: 'Ordered Date',
      type: 'date',
      hideInTable: true,
      size: 65,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    {
      accessorKey: 'isServiceCompleted',
      header: 'Service Completed',
      type: 'checkbox',
      size: 65
    }
  ];
};

const parseLanguageTrainingFormValues = (currentRequest, v) => {
  currentRequest.familyMemberId = v.familyMemberId ?? null;
  currentRequest.languageTrainingVendorId = v.vendorId ?? null;
  currentRequest.languageTrainingVendorContactId = v.contactId ?? null;
  currentRequest.hoursApproved = parseFormValue(v.hoursApproved, ValueType.IntType);
  currentRequest.hourlyRate = parseFormValue(v.hourlyRate, ValueType.FloatType);
  currentRequest.hoursAttended = parseFormValue(v.hoursUsed, ValueType.IntType); // Map hoursUsed back to hoursAttended for API
  currentRequest.initiationDate = parseFormValue(v.orderedDate, ValueType.DateTimeType); // Map orderedDate back to initiationDate for API
  currentRequest.originCity = '';
  currentRequest.originCountryId = ZERO_GUID;
  currentRequest.destinationCity = '';
  currentRequest.destinationCountryId = ZERO_GUID;
  currentRequest.isServiceCompleted = v.isServiceCompleted ?? false;
};
